'use client';

import { ArrowRight } from 'lucide-react';
import ImpactFooter from '@/components/sections/impact-footer';

export default function WhatWeDoContent() {
  return (
    <main className="relative bg-ivory">
      {/* Introduction Section */}
      {/* <section className="pt-32 pb-16">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto text-center mb-12">
            <h1 className="heading-1 text-oxford mb-6">
              What We Do
            </h1>
            <p className="text-xl text-oxford/80 max-w-3xl mx-auto">
              At Micro Leaps, we are reimagining education to truly prepare students for the workforce. Over 18 years with us, children will experience learning that builds essential skills, confidence, and career awareness—ensuring education leads to meaningful employment.
            </p>
          </div>
        </div>
      </section> */}

      {/* Our Vision Section */}
      <section className="py-16 bg-ivory">
        <div className="container-custom">
          <div className="text-center mb-10">
            <h2 className="heading-2 text-oxford mb-6">Our Vision</h2>
            <div className="w-32 h-1 bg-dark-peach mx-auto mb-10"></div>
            
            <div className="max-w-4xl mx-auto px-4">
              <p className="font-heading text-3xl md:text-4xl lg:text-5xl text-oxford leading-tight">
                <span className="font-bold">Every Child is <span className="underline decoration-dark-peach decoration-4 underline-offset-8">Owed</span></span>
                <span className="block mt-3">an Education That Leads to a Life of Dignity.</span>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Mission Section */}
      <section className="pt-16 pb-16 bg-butterscotch/10">
        <div className="container-custom">
          <div className="text-center mb-10">
            <h2 className="heading-2 text-oxford mb-6">Our Mission</h2>
            <div className="w-32 h-1 bg-dark-peach mx-auto mb-8"></div>
            
            <div className="max-w-4xl mx-auto px-4">
              <p className="text-lg text-oxford/80 max-w-3xl mx-auto">
                Make schools personal, relevant and experiential to empower every child to build 21st-century skills to break cycles of poverty through meaningful employment.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Growth Journey Section - Moved to top */}
      <section className="pt-16 pb-16 bg-mid-blue/10">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="heading-2 text-oxford mb-4">Our Growth Journey</h2>
            <div className="w-24 h-1 bg-dark-peach mx-auto mb-8"></div>
            <p className="text-lg text-oxford/80 max-w-3xl mx-auto">
              At Micro Leaps, we are reimagining education to truly prepare students for the workforce. Over 18 years with us, children will experience learning that builds essential skills, confidence, and career awareness—ensuring education leads to meaningful employment.
            </p>
          </div>

          {/* Featured Image */}
          <div className="relative w-full max-w-4xl mx-auto mb-16 rounded-xl overflow-hidden shadow-xl">
            <div className="aspect-w-16 aspect-h-9 relative">
              <img
                src="/page2/micro_leaps_journey_growth_lq.webp"
                alt="Micro Leaps Growth Journey"
                width={1200}
                height={675}
                className="object-cover rounded-xl"
                // blurDataURL="/pages/micro_leaps_journey_growth_vlq.jpg"
              />
            </div>
          </div>

          {/* Simplified Horizontal Timeline */}
          <div className="max-w-5xl mx-auto">
            {/* Timeline Container with Relative Positioning */}
            <div className="relative pb-8">
              {/* Timeline Line */}
              <div className="h-2 bg-gradient-to-r from-mid-blue via-jellyfish to-dark-peach rounded-full"></div>
              
              {/* Date Markers - Positioned directly on the timeline */}
              <div className="absolute top-0 left-[12.5%] transform -translate-x-1/2 -translate-y-1/2">
                <div className="bg-mid-blue text-ivory size-16 rounded-full flex flex-col items-center justify-center shadow-md">
                  <span className="text-sm font-medium">Sept</span>
                  <span className="text-lg font-bold">'24</span>
                </div>
              </div>
              
              <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                <div className="bg-jellyfish text-ivory size-16 rounded-full flex flex-col items-center justify-center shadow-md">
                  <span className="text-sm font-medium">Jan</span>
                  <span className="text-lg font-bold">'25</span>
                </div>
              </div>
              
              <div className="absolute top-0 left-[87.5%] transform -translate-x-1/2 -translate-y-1/2">
                <div className="bg-dark-peach text-ivory size-16 rounded-full flex flex-col items-center justify-center shadow-md">
                  <span className="text-sm font-medium">May</span>
                  <span className="text-lg font-bold">'25</span>
                </div>
              </div>
            </div>
            
            {/* Timeline Cards - In a grid below the timeline */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
              {/* September 2024 */}
              <div>
                <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-all duration-300 hover:-translate-y-1 h-full flex flex-col">
                  <div className="flex items-center justify-between mb-4">
                    <div className="bg-butterscotch text-oxford px-4 py-2 rounded-full font-medium">7 Students</div>
                    <div className="bg-oxford/10 text-oxford px-4 py-2 rounded-full font-medium">1 Centre</div>
                  </div>
                  
                  {/* Simple Progress Bar */}
                  <div className="h-2 w-full bg-oxford/10 rounded-full mb-4 overflow-hidden">
                    <div className="h-full bg-mid-blue rounded-full" style={{width: '10%'}}></div>
                  </div>
                  
                  <div className="h-0.5 w-16 bg-dark-peach mb-4"></div>
                  <p className="text-oxford/80 flex-grow">
                    We launched our first center, welcoming our inaugural group of students.
                  </p>
                  
                  {/* Growth Indicator */}
                  <div className="mt-4 flex items-center text-oxford/70">
                    <svg xmlns="http://www.w3.org/2000/svg" className="size-5 text-mid-blue mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
                    </svg>
                    <span>Initial Launch</span>
                  </div>
                </div>
              </div>
              
              {/* January 2025 */}
              <div>
                <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-all duration-300 hover:-translate-y-1 h-full flex flex-col">
                  <div className="flex items-center justify-between mb-4">
                    <div className="bg-butterscotch text-oxford px-4 py-2 rounded-full font-medium">30 Students</div>
                    <div className="bg-oxford/10 text-oxford px-4 py-2 rounded-full font-medium">2 Centres</div>
                  </div>
                  
                  {/* Simple Progress Bar */}
                  <div className="h-2 w-full bg-oxford/10 rounded-full mb-4 overflow-hidden">
                    <div className="h-full bg-jellyfish rounded-full" style={{width: '30%'}}></div>
                  </div>
                  
                  <div className="h-0.5 w-16 bg-dark-peach mb-4"></div>
                  <p className="text-oxford/80 flex-grow">
                    Our community expanded as we opened our second center.
                  </p>
                  
                  {/* Growth Indicator */}
                  <div className="mt-4 flex items-center text-oxford/70">
                    <svg xmlns="http://www.w3.org/2000/svg" className="size-5 text-jellyfish mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                    </svg>
                    <span>328% Growth</span>
                  </div>
                </div>
              </div>
              
              {/* May 2025 */}
              <div>
                <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-all duration-300 hover:-translate-y-1 h-full flex flex-col">
                  <div className="flex items-center justify-between mb-4">
                    <div className="bg-butterscotch text-oxford px-4 py-2 rounded-full font-medium">100 Students</div>
                    <div className="bg-oxford/10 text-oxford px-4 py-2 rounded-full font-medium">4 Centres</div>
                  </div>
                  
                  {/* Simple Progress Bar */}
                  <div className="h-2 w-full bg-oxford/10 rounded-full mb-4 overflow-hidden">
                    <div className="h-full bg-dark-peach rounded-full" style={{width: '100%'}}></div>
                  </div>
                  
                  <div className="h-0.5 w-16 bg-dark-peach mb-4"></div>
                  <p className="text-oxford/80 flex-grow">
                    Our vision continues to scale, bringing our model to more communities.
                  </p>
                  
                  {/* Growth Indicator */}
                  <div className="mt-4 flex items-center text-oxford/70">
                    <svg xmlns="http://www.w3.org/2000/svg" className="size-5 text-dark-peach mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                    </svg>
                    <span>233% Growth</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Four Key Strategies Section */}
      <section className="py-16 bg-jellyfish/10">
        <div className="container-custom">
          <div className="text-center mb-16">
            <h2 className="heading-2 text-oxford mb-4">Our Four Key Strategies</h2>
            <div className="w-24 h-1 bg-dark-peach mx-auto mb-8"></div>
            <p className="text-lg text-oxford/80 max-w-3xl mx-auto">
              We focus on four interconnected approaches that prepare students for success in education and beyond.
            </p>
          </div>

          {/* Strategy Cards - Interactive Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
            {/* Strategy 1 */}
            <div className="group relative overflow-hidden rounded-xl shadow-lg border border-oxford/10 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 h-[28rem]">
              <div className="absolute inset-0 z-0">
                <img
                  src="/page2/building_independant_learners_lq.webp"
                  alt="Building Independent Learners"
                  // fill
                  className="object-cover transition-transform duration-500 group-hover:scale-105"
                  // blurDataURL="/pages/building_independant_learners_vlq.jpg"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-oxford to-transparent opacity-80"></div>
              </div>
              <div className="absolute top-6 left-6 z-10">
                <div className="bg-mid-blue text-ivory w-14 h-14 rounded-full flex items-center justify-center text-2xl font-heading shadow-lg">
                  1
                </div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6 z-10 transform transition-transform duration-300">
                <h3 className="font-heading text-2xl text-ivory mb-3">Building Independent Learners with Technology</h3>
                <div className="h-0.5 w-16 bg-dark-peach mb-4"></div>
                <ul className="space-y-3 text-ivory/90">
                  <li className="flex items-start">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-dark-peach mr-2 flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Students set and track their own academic and personal goals.</span>
                  </li>
                  <li className="flex items-start">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-dark-peach mr-2 flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Digital tools help them become self-directed, reducing reliance on teacher-led instruction.</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Strategy 2 */}
            <div className="group relative overflow-hidden rounded-xl shadow-lg border border-oxford/10 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 h-[28rem]">
              <div className="absolute inset-0 z-0">
                <img
                  src="/page2/community_based_projects_lq.webp"
                  alt="Community-Based Projects"
                  // fill
                  className="object-cover transition-transform duration-500 group-hover:scale-105"
                  // blurDataURL="/page2/community_based_projects_lq.jpg"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-oxford to-transparent opacity-80"></div>
              </div>
              <div className="absolute top-6 left-6 z-10">
                <div className="bg-jellyfish text-ivory w-14 h-14 rounded-full flex items-center justify-center text-2xl font-heading shadow-lg">
                  2
                </div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6 z-10 transform transition-transform duration-300">
                <h3 className="font-heading text-2xl text-ivory mb-3">Community-Based Projects & Real-World Problem Solving</h3>
                <div className="h-0.5 w-16 bg-dark-peach mb-4"></div>
                <ul className="space-y-3 text-ivory/90">
                  <li className="flex items-start">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-dark-peach mr-2 flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Students engage in hands-on projects that solve real challenges in their communities.</span>
                  </li>
                  <li className="flex items-start">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-dark-peach mr-2 flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span>A design thinking approach fosters critical thinking, creativity, and collaboration.</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Strategy 3 */}
            <div className="group relative overflow-hidden rounded-xl shadow-lg border border-oxford/10 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 h-[28rem]">
              <div className="absolute inset-0 z-0">
                <img
                  src="/page2/one_on_one_mentorship.webp"
                  alt="One-on-One Mentorship"
                  // fill
                  className="object-cover transition-transform duration-500 group-hover:scale-105"
                  // blurDataURL="/page2/one_on_one_mentorship.jpg"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-oxford to-transparent opacity-80"></div>
              </div>
              <div className="absolute top-6 left-6 z-10">
                <div className="bg-butterscotch text-oxford w-14 h-14 rounded-full flex items-center justify-center text-2xl font-heading shadow-lg">
                  3
                </div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6 z-10 transform transition-transform duration-300">
                <h3 className="font-heading text-2xl text-ivory mb-3">One-on-One Mentorship for Growth</h3>
                <div className="h-0.5 w-16 bg-dark-peach mb-4"></div>
                <ul className="space-y-3 text-ivory/90">
                  <li className="flex items-start">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-dark-peach mr-2 flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Every student is paired with a mentor for guidance, goal setting, and accountability.</span>
                  </li>
                  <li className="flex items-start">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-dark-peach mr-2 flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Mentors support academic and personal development, ensuring steady progress.</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Strategy 4 */}
            <div className="group relative overflow-hidden rounded-xl shadow-lg border border-oxford/10 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 h-[28rem]">
              <div className="absolute inset-0 z-0">
                <img
                  src="/page2/career_awareness_lq.webp"
                  alt="Career Awareness"
                  // fill
                  className="object-cover transition-transform duration-500 group-hover:scale-105"
                  // blurDataURL="/page2/career_awareness_vlq.jpg"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-oxford to-transparent opacity-80"></div>
              </div>
              <div className="absolute top-6 left-6 z-10">
                <div className="bg-dark-peach text-ivory w-14 h-14 rounded-full flex items-center justify-center text-2xl font-heading shadow-lg">
                  4
                </div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6 z-10 transform transition-transform duration-300">
                <h3 className="font-heading text-2xl text-ivory mb-3">Career Awareness & Aspirational Pathways</h3>
                <div className="h-0.5 w-16 bg-dark-peach mb-4"></div>
                <ul className="space-y-3 text-ivory/90">
                  <li className="flex items-start">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-dark-peach mr-2 flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Most students know only 7 of the 250+ career options available.</span>
                  </li>
                  <li className="flex items-start">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-dark-peach mr-2 flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Through industry exposure, career talks, and mentorship, we help students explore and pursue meaningful careers.</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <ImpactFooter />
    </main>
  );
} 